// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 7177 ? "react-hotjar" : chunkId) + "." + {"3471":"f2799854","3486":"5ddc5154","3573":"950acb06","7177":"c3774e85","7470":"f0213baa"}[chunkId] + ".chunk.js";
};